<script>
import Vue from 'vue'
import { List } from 'vant'
import ProjectListItem from './ProjectListItem'
import { searchProjectList } from '~/api/community.api'

Vue.use(List)
export default {
  components: {
    ProjectListItem
  },
  // :style="filter.style"
  // :home="filter.home"
  // :district="filter.district"
  // :sort="filter.sort"
  props: {
    filter: {
      default: () => {
        return {}
      },
      type: Object
    }
    // style: {
    //   default: '',
    //   type: String
    // },
    // home: {
    //   default: '',
    //   type: String
    // },
    // district: {
    //   default: '',
    //   type: String
    // },
    // sort: {
    //   default: '',
    //   type: String
    // }
  },
  data() {
    return {
      projectList: [],
      isLoading: false,
      isLastPage: false,
      pageNo: 1,
      pageSize: 10
    }
  },
  watch: {
    filter: {
      deep: true,
      handler(newVal, oldVal) {
        this.pageNo = 1
        this.projectList = []
        this.isLastPage = false
        this.GetSearchProjectList()
      }
    }
  },
  created() {
    this.GetSearchProjectList()
  },
  methods: {
    GetSearchProjectList
  }
}

async function GetSearchProjectList() {
  const vm = this
  if (vm.isLastPage) return
  vm.isLoading = true

  const res = await searchProjectList({
    pageNo: vm.pageNo,
    pageSize: vm.pageSize,
    latitude: 31.25956,
    longititude: 121.52609,
    region: vm.filter.region ? vm.filter.region : '',
    style: vm.filter.style ? vm.filter.style : '',
    room: vm.filter.room || vm.filter.room === 0 ? vm.filter.room : '',
    sort: vm.filter.sort ? vm.filter.sort : '',
    // personId: 10917,
    companyId: this.$route.params.companyId,
    isdisplay: 'N'
  })
  vm.projectList = vm.projectList.concat(res)
  if (res.length < vm.pageSize) {
    vm.isLastPage = true
  }
  vm.pageNo++
  vm.isLoading = false
}
</script>

<template>
  <div class="project_list_list_components_container">
    <van-list
      v-model="isLoading"
      :finished="isLastPage"
      finished-text="没有更多了"
      :offset="500"
      :immediate-check="false"
      @load="GetSearchProjectList"
    >
      <div v-for="(projectItem, index) in projectList" :key="index">
        <nuxt-link
          :to="
            `/company/${$route.params.companyId}/project/${projectItem.projectId}`
          "
          append
          :target="$_newtab"
        >
          <ProjectListItem :project-item="projectItem" />
        </nuxt-link>
      </div>
    </van-list>
  </div>
</template>

<style lang="scss" scoped>
.project_list_list_components_container {
  overflow: auto;
  height: 100%;
}
</style>
